import { render, staticRenderFns } from "./nearest-reports.page.vue?vue&type=template&id=95bb2f02&scoped=true"
import script from "./nearest-reports.page.vue?vue&type=script&lang=ts"
export * from "./nearest-reports.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bb2f02",
  null
  
)

export default component.exports